import { render } from "./UserBadge.vue?vue&type=template&id=307ec71a&scoped=true"
import script from "./UserBadge.vue?vue&type=script&lang=js"
export * from "./UserBadge.vue?vue&type=script&lang=js"

import "./UserBadge.vue?vue&type=style&index=0&id=307ec71a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307ec71a"]])

export default __exports__